import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { PurchaseOrderDTO } from 'src/app/purchase/purchase-order/purchase-order.interface';
import { PurchaseOrderService } from 'src/app/purchase/purchase-order/purchase-order.services';
import { PurchaseOrderDetailDTO } from 'src/app/purchase/purchase-order/purchase-order-detail/purchase-order-detail.interface';
import { PurchaseOrderDetailService } from 'src/app/purchase/purchase-order/purchase-order-detail/purchase-order-detail.services';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-via-purchase-order-button',
  templateUrl: './add-via-purchase-order-button.component.html',
  styleUrls: ['./add-via-purchase-order-button.component.css']
})
export class AddViaPurchaseOrderButtonComponent {
  // Emitters 
  @Input() EnablePriceEdit: boolean = false
  @Input({ required: true }) MasterId: number = 0
  @Input({ required: true }) MasterType: string = ''
  @Output() onSubmit: EventEmitter<PurchaseOrderDetailDTO[]> = new EventEmitter<PurchaseOrderDetailDTO[]>();

  // flags
  isSubmitting: boolean = false
  PurchaseOrderNo = new FormControl('')
  toastr = inject(ToastrService)
  title = 'Purchase Order'
  dataLoading: boolean = false

  // services
  modalService = inject(NgbModal)
  User = inject(UserLoginService).User();
  PurchaseOrderService = inject(PurchaseOrderService)
  PurchaseOrderDetailService = inject(PurchaseOrderDetailService)

  //Items
  purchaseOrderList: PurchaseOrderDTO[] = [];   // search results
  SelectedPurchaseOrderItems: PurchaseOrderDetailDTO[] = []; // table
  SelectedDetailItems: PurchaseOrderDetailDTO[] = [];

  // modal ref 
  purchaseOrderModalRef!: NgbModalRef
  @ViewChild('PurchaseOrderItemModal', { static: true }) PurchaseOrderModalTemplate!: ElementRef

  changeAllQty(event: any) {
    const value = Number(event.target.value);
    this.SelectedPurchaseOrderItems.forEach(i => i.qty = value);
  }

  ngOnInit() {
    this.PurchaseOrderNo.valueChanges.subscribe(res => {
      if (res) {
        this.GetItemsByPurchaseOrderId(Number(res));
      }
    });
  }

  searchLoading: boolean = false;
  openModal() {
    this.PurchaseOrderNo.reset();
    this.purchaseOrderList = [];
    this.SelectedDetailItems = [];
    this.SelectedPurchaseOrderItems = [];
    this.searchLoading = true;

    this.PurchaseOrderService.PurchaseOrder_SearchByPurchaseOrderNo({
      purchaseOrderNo: '',
      tenantId: Number(this.User.companyId),
      tenantBranchId: this.User.loggedInBranchId,
    }).subscribe(res => {
      this.purchaseOrderList = res.items;
      this.searchLoading = false;
    });
    this.purchaseOrderModalRef = this.modalService.open(this.PurchaseOrderModalTemplate, { size: 'lg', backdrop: 'static' });
  }

  GetItemsByPurchaseOrderId(purchaseOrderId: number) {
    this.dataLoading = true
    // Switching order: drop ticks from the previous one so they aren't imported with this one
    this.SelectedDetailItems = [];
    this.PurchaseOrderDetailService.PurchaseOrderDetail_ReadByPurchaseOrderIdForImport({
      purchaseOrderId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      masterId: this.MasterId,
      masterType: this.MasterType
    }).subscribe(res => {
      this.SelectedPurchaseOrderItems = res.items;
      this.SelectedPurchaseOrderItems.forEach(item => {
        // Initialize qty with the current qty value
        item.qty = item.qty || 0;
      });
      this.dataLoading = false
    })
  }

  submitResults() {
    if (this.SelectedDetailItems.length === 0) {
      this.toastr.warning('Please select at least one item');
      return;
    }

    this.isSubmitting = true
    this.onSubmit.emit(this.SelectedDetailItems)
    setTimeout(() => {
      this.isSubmitting = false;
      this.purchaseOrderModalRef.close();
      this.resetSelection();
    }, 500);
  }

  resetSelection() {
    this.PurchaseOrderNo.reset();
    this.SelectedDetailItems = [];
    this.SelectedPurchaseOrderItems = [];
  }


  onSelctionCheckboxChange(event: any, item: PurchaseOrderDetailDTO) {
    item.isSelected = event.target.checked;
    let isDuplicate = this.SelectedDetailItems.find(i => i.purchaseOrderDetailId == item.purchaseOrderDetailId);

    if (event.target.checked) {
      if (!isDuplicate) this.SelectedDetailItems.push(item);
    } else {
      this.SelectedDetailItems = this.SelectedDetailItems.filter(i => i.purchaseOrderDetailId != item.purchaseOrderDetailId);
    }
    console.log(this.SelectedDetailItems);
  }

  onSelectAllCheckboxChange(event: any) {
    if (event.target.checked) {
      // Clear previous selections
      this.SelectedDetailItems = [];
      this.SelectedPurchaseOrderItems.forEach(i => i.isSelected = true);
      this.SelectedDetailItems = [...this.SelectedPurchaseOrderItems];
    } else {
      this.SelectedPurchaseOrderItems.forEach(i => i.isSelected = false);
      this.SelectedDetailItems = [];
    }
    console.log(this.SelectedDetailItems);
  }

  // Search 
  SearchPurchaseOrder(event: { term: string; items: any[]; }) {
    console.log(event.term);
    setTimeout(() => {
      this.searchLoading = true;

      this.PurchaseOrderService.PurchaseOrder_SearchByPurchaseOrderNo({
        purchaseOrderNo: event.term,
        tenantId: Number(this.User.companyId),
        tenantBranchId: this.User.loggedInBranchId,
      }).subscribe(res => {
        this.purchaseOrderList = res.items;
        this.searchLoading = false;
      });

    }, 500);
  }
}
